import React, { useState, useEffect } from "react";
import logo from '../../Assets/titulo.png';
import { useLocation } from 'react-router-dom';
import styles from './NavBar.module.css';

const NavBar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeLink, setActiveLink] = useState(null);
    const location = useLocation();

    const handleNavLinkClick = (link) => {
        setActiveLink(link);
        setMenuOpen(false); // Cerrar el menú al hacer clic en un enlace
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

        // Bloquear o desbloquear el scroll del body
        useEffect(() => {
            if (menuOpen) {
                document.body.style.overflow = "hidden"; // Bloquea el scroll
            } else {
                document.body.style.overflow = "auto"; // Habilita el scroll
            }
            return () => {
                document.body.style.overflow = "auto"; // Limpieza al desmontar
            };
        }, [menuOpen]);

    return (
        <nav className={styles.navbar}>
            {/* Logo a la izquierda */}
            <div className={styles.logoContainer}>
                <a href="/">
                    <img src={logo} alt="Logo" className={styles.img} />
                </a>
            </div>

            {/* Botón de hamburguesa (solo visible en móviles) */}
            <button className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`} onClick={toggleMenu}>
                <div className={styles.bar}></div>
                <div className={styles.bar}></div>
                <div className={styles.bar}></div>
            </button>

            {/* Menú para dispositivos móviles */}
            {menuOpen && <div className={styles.mobileMenuOverlay} onClick={() => setMenuOpen(false)}></div>}
            <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}>
                <div className={styles.mobileMenuContent}>
                    <a 
                        href="/" 
                        onClick={() => handleNavLinkClick('home')} 
                        className={activeLink === 'home' ? styles.activeLink : ''}>
                        Home
                    </a>
                    <a 
                        href="/sale" 
                        onClick={() => handleNavLinkClick('comprar')} 
                        className={activeLink === 'comprar' ? styles.activeLink : ''}>
                        Comprar
                    </a>
                    <a 
                        href="/sell" 
                        onClick={() => handleNavLinkClick('vender')} 
                        className={activeLink === 'vender' ? styles.activeLink : ''}>
                        Vender
                    </a>
                    <a 
                        href="/rent" 
                        onClick={() => handleNavLinkClick('alquilar')} 
                        className={activeLink === 'alquilar' ? styles.activeLink : ''}>
                        Alquilar
                    </a>
                    <a 
                        href="/desarrollo" 
                        onClick={() => handleNavLinkClick('desarrollo')} 
                        className={activeLink === 'desarrollo' ? styles.activeLink : ''}>
                        Desarrollos
                    </a>
                    {/* <a 
                        href="/franquicias" 
                        onClick={() => handleNavLinkClick('franquicias')} 
                        className={activeLink === 'franquicias' ? styles.activeLink : ''}>
                        Franquicias
                    </a> */}
                    <a 
                        href="/oficina" 
                        onClick={() => handleNavLinkClick('oficina')} 
                        className={activeLink === 'oficina' ? styles.activeLink : ''}>
                        Staff
                    </a>
                    <a 
                        href="/contact" 
                        onClick={() => handleNavLinkClick('contacto')} 
                        className={activeLink === 'contacto' ? styles.activeLink : ''}>
                        Contacto
                    </a>
                </div>
            </div>

            {/* Menú para escritorio */}
            <div className={styles.navLinks}>
    <a 
        href="/" 
        className={location.pathname === '/' ? styles.activeLink : ''}>
        Home
    </a>
    <a 
        href="/sale" 
        className={location.pathname === '/sale' ? styles.activeLink : ''}>
        Comprar
    </a>
    <a 
        href="/sell" 
        className={location.pathname === '/sell' ? styles.activeLink : ''}>
        Vender
    </a>
    <a 
        href="/rent" 
        className={location.pathname === '/rent' ? styles.activeLink : ''}>
        Alquilar
    </a>
    <a 
        href="/desarrollo" 
        className={location.pathname === '/desarrollo' ? styles.activeLink : ''}>
        Desarrollos
    </a>
    {/* <a 
        href="/franquicias" 
        className={location.pathname === '/franquicias' ? styles.activeLink : ''}>
        Franquicias
    </a> */}
    <a 
        href="/oficina" 
        className={location.pathname === '/oficina' ? styles.activeLink : ''}>
        Staff
    </a>
    <a 
        href="/contact" 
        className={location.pathname === '/contact' ? styles.activeLink : ''}>
        Contacto
    </a>
</div>
        </nav>
    );
};

export default NavBar;
